export const PORTUGUESE_TAX = '23';
